import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import {request} from '../../../api-client'
import localization from '../../../config/localization'
import moment from "moment";
import TableButton from "../../../components/Letflow/Table/Buttons/TableButton";
import {Edit, FilterNone, PlayArrow} from "@material-ui/icons";
import {
  FormControl,
  FormControlLabel, IconButton,
  Radio,
  RadioGroup, Tooltip,
} from "@material-ui/core/index";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {homePathGenerator, slugify} from "../../../api-client/core/authentication/utils";
let table

class Table extends Component {
  state = {
    total: "",
    showLivestreams: 'all',
    loaded: false,
    typeFilter: ""
  };
  componentDidUpdate = prevProps => {
    if (prevProps.refresh !== this.props.refresh) {
        table.forceUpdate();
    }
  };

  makeLivestreamTypeColumn = (livestream) => {
    let type = localization.get(`livestream${livestream.fake ? '.fake' : ''}`)
    let source = localization.get(`form.${livestream.source}`)

    return `${type} ${livestream.source ? `(${source})` : ''}`
  }

  columns = () => [
    {
      Header: localization.get('table.name'),
      accessor: "name",
      sortable: false,
      Filter: ({filter, onChange}) => (
        <input
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ''}
          placeholder={localization.get('table.search')}
        />
      ),
    },
    {
      Header: localization.get('table.type'),
      Cell: ({ original }) => <span>{this.makeLivestreamTypeColumn(original)}</span>,
      sortable: false,
      id: "source",
      Filter: ({filter, onChange}) => (
        <select
          style={{width: "100%"}}
          onChange={event => this.setState({typeFilter: event.target.value}, () => table.forceUpdate())}
          value={this.state.typeFilter}
        >
          <option value="" selected/>
          <option value={"vimeo"}>Vimeo</option>
          <option value={"vimeoLive"}>Vimeo Live</option>
          <option value={"youtube"}>YouTube</option>
        </select>
      ),
    },
    {
      Header: localization.get("table.date"),
      accessor: "start_time",
      Cell: ({ value }) => <span>{moment.utc(value).local().format("DD/MM/YYYY LT")}</span>,
      width: 160,
      filterable: false,
      sortable: false,
    },
    {
      id: "actions",
      sortable: false,
      filterable: false,
      maxWidth: 140,
      accessor: livestream => {
        const buttonBuilder = new TableButtonsBuilder()

        if (this.props.showLivestreams !== 'finished') {
          buttonBuilder.withOther(
            <TableButton
              title={localization.get('copy')}
            >
              <Tooltip placement="top" title={this.state.copied}>
                <CopyToClipboard text={process.env.REACT_APP_WEB_HOST + homePathGenerator(`vivo/${livestream.id}-${slugify(livestream.name)}`)}>
                  <IconButton>
                    <FilterNone />
                  </IconButton>
                </CopyToClipboard>
              </Tooltip>
            </TableButton>, process.env.REACT_APP_WEB_HOST + homePathGenerator(`vivo/${livestream.id}-${slugify(livestream.name)}`))

          buttonBuilder.withOther(
            <TableButton
              title={localization.get("reel.edit_thumbnail_tooltip")}
              onClick={() => window.open(`/panel/livestreams/${livestream.id}/preview`, '_blank')}
            >
              <PlayArrow />
            </TableButton>
          );

          buttonBuilder.withOther(
            <TableButton
              title={localization.get("edit")}
              onClick={() => this.props.onEdit(livestream.id)}
            >
              <Edit />
            </TableButton>
          );

          buttonBuilder.withDelete(
            livestream.name,
            () => request.liveStream.delete(livestream.id),
            state => {
              if (state === "passed") {
                table.removeById(livestream.id)
              }
            }
          )
        }
        return buttonBuilder.build()
      }
    },
  ]

  render = () => {
    return (
      <div style={{padding: "0 15px 15px"}}>
        <FormControl style={{width: "100%", float: "left", position: "relative"}}>
          <RadioGroup
            name="showLivestreams"
            value={this.state.showLivestreams}
            onChange={event => {
              this.setState({ showLivestreams: event.target.value })
              table.forceUpdate();
            }}
            style={{ width: "100%", float: "left", position: "relative", flexDirection: "row" }}
          >
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="all" control={<Radio color="default" />} label={localization.get('clients.all')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="scheduled" control={<Radio color="default" />} label={localization.get('clients.active')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="finished" control={<Radio color="default" />} label={localization.get('clients.inactive')} />
          </RadioGroup>
        </FormControl>
        <ServerSidePaginationTable
          style={{width: "100%", float: "left", position: "relative"}}
          ref={r => table = r}
          columns={this.columns()}
          perPage={12}
          showPaginationBottom
          readAndWriteUrl={false}
          requestTableData={paginationConfig => {
            paginationConfig.orderBy = {column: "start_time", type: this.state.showLivestreams !== 'finished' ? "asc" : "desc"}
            if(this.state.showLivestreams !== 'all') {
              paginationConfig = {
                ...paginationConfig,
                filterBy: paginationConfig.filterBy.concat([{
                  column: 'finished',
                  filter: this.state.showLivestreams === 'finished' ? 1 : 0
                }])
              }
            }

            if (this.state.typeFilter !== "") {
              paginationConfig = {
                ...paginationConfig,
                filterBy: paginationConfig.filterBy.concat([{
                  column: 'source',
                  filter: this.state.typeFilter
                }])
              }
            }

            return request.liveStream.getAll(paginationConfig).then(response => {
              this.setState({total: response.meta.total});
              return response;
            });

          }}
        />
      </div>
    )
  }
}


export default Table
